import * as z from "zod/v4";

export const updateIntegrationToolParamsSchema = z.object({
  type: z.enum(["BlueYonder"]),
});

export type UpdateIntegrationToolParams = z.infer<
  typeof updateIntegrationToolParamsSchema
>;
